import { isAuctionStyleEndVehicle } from 'components/card/Buyers/Helpers';
import { MKT_STATUS_TYPE } from 'helpers/marketplaceStatus';
import { getCounterOfferStatus } from '../dealWorking';

export const getLiveOvertimeBubble = (currentUserTopOfferer, currentUserHasOffered, vehicle) => {
	const { acceptable_counter_offer_activity } = vehicle || {};
	if (isAuctionStyleEndVehicle(vehicle) && acceptable_counter_offer_activity) {
		return getCounterOfferStatus(vehicle);
	}

	if (currentUserTopOfferer) {
		return { unifiedStatusType: MKT_STATUS_TYPE.leader };
	} else if (currentUserHasOffered) {
		return { unifiedStatusType: MKT_STATUS_TYPE.outbid };
	}
	return { unifiedStatusType: MKT_STATUS_TYPE.otherLeader };
};
